module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_6000.a565d2e2.png";